import { render } from "./ProfitLossReport.vue?vue&type=template&id=01b10cc6&scoped=true"
import script from "./ProfitLossReport.vue?vue&type=script&lang=js"
export * from "./ProfitLossReport.vue?vue&type=script&lang=js"

import "./ProfitLossReport.vue?vue&type=style&index=0&id=01b10cc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b10cc6"]])

export default __exports__